import React from 'react';
import { Polyline } from '@react-google-maps/api';
import { PlannedRoute } from '../../types/deliveryRoute';

export const TRAVELED_COLOR = '#3B82F6';
export const PLANNED_COLOR = '#FE2445';

type LatLngLike = { latitude: number | string; longitude: number | string };
const toPath = (points: LatLngLike[]) => points.map((p) => ({ lat: Number(p.latitude), lng: Number(p.longitude) }));

/**
 * Recorrido del domiciliario (línea sólida) y la ruta que le falta según la última recomendación
 * del backend (punteada). No llama a Google: los puntos vienen del backend. Va dentro de un <GoogleMap>.
 */
export const CourierRouteLines: React.FC<{ traveled?: LatLngLike[]; planned?: PlannedRoute | null }> = ({ traveled = [], planned }) => (
    <>
        {traveled.length > 1 && (
            <Polyline path={toPath(traveled)} options={{ strokeColor: TRAVELED_COLOR, strokeOpacity: 0.9, strokeWeight: 5, zIndex: 2 }} />
        )}
        {planned && planned.points.length > 1 && (
            <Polyline
                path={toPath(planned.points)}
                options={{
                    strokeOpacity: 0,
                    zIndex: 1,
                    icons: [{ icon: { path: 'M 0,-1 0,1', strokeColor: PLANNED_COLOR, strokeOpacity: 0.9, strokeWeight: 3, scale: 3 }, offset: '0', repeat: '12px' }],
                }}
            />
        )}
    </>
);

// "8 min · 2.4 km" de la ruta planeada y hace cuánto se calculó
export const plannedSummary = (planned: PlannedRoute) => {
    const parts: string[] = [];
    if (planned.duration_seconds !== null) parts.push(`${Math.max(1, Math.round(planned.duration_seconds / 60))} min`);
    if (planned.distance_meters !== null) parts.push(`${(planned.distance_meters / 1000).toFixed(1)} km`);
    const computedAt = new Date(planned.computed_at.replace(' ', 'T'));
    const minutesAgo = isNaN(computedAt.getTime()) ? null : Math.max(0, Math.round((Date.now() - computedAt.getTime()) / 60000));
    return { estimate: parts.join(' · '), computedAgo: minutesAgo === null ? '' : minutesAgo === 0 ? 'calculada hace menos de 1 min' : `calculada hace ${minutesAgo} min` };
};

// Leyenda para poner debajo del mapa
export const RouteLegend: React.FC<{ destinationHidden?: boolean }> = ({ destinationHidden }) => (
    <div className="d-flex flex-wrap align-items-center gap-3 small text-body-secondary mt-2 px-1">
        <span className="d-inline-flex align-items-center gap-1">
            <span className="d-inline-block rounded-pill" style={{ width: 18, height: 4, backgroundColor: TRAVELED_COLOR }} /> Recorrido
        </span>
        <span className="d-inline-flex align-items-center gap-1">
            <span className="d-inline-block" style={{ width: 18, borderTop: `3px dashed ${PLANNED_COLOR}` }} /> Ruta que va a seguir
        </span>
        {destinationHidden && <span>El tramo final cerca del cliente no se muestra.</span>}
    </div>
);
